import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CategroizedXraysPipe } from './categorized-xrays.pipe';
import { FilterActiveGroupPipe } from './filter-active-group.pipe';
import { FilterMatchedCategoriesPipe } from './filter-empty-categories-group.pipe';
import { FilterGroupsWithStudiesPipe } from './filter-groups-with-studies.pipe';
import { FilterSaleHorsePipe } from './filter-horse.pipe';
import { FilterStudyFilesByGroupPipe } from './filter-study-files-by-group.pipe';
import { GetCategoryNamePipe } from './get-category-name.pipe';
import { LeftOrRightPipe } from './left-or-right.pipe';
import { SaleInviteAccessPipe, SaleRequestAccessPipe } from './sale-request-access.pipe';
import { SortStudiesByCategoryPipePipe } from './sort-studies-by-category.pipe';
import { IsSelectedStudiesPipe } from './sort-studies-by-category.pipe copy';
import { WithCategoryPipe } from './withCategory.pipe';
import { WithStudyFilePipe } from './withStudyFile.pipe';

@NgModule({
  declarations: [
    FilterSaleHorsePipe,
    FilterStudyFilesByGroupPipe,
    FilterActiveGroupPipe,
    LeftOrRightPipe,
    FilterGroupsWithStudiesPipe,
    SortStudiesByCategoryPipePipe,
    WithStudyFilePipe,
    GetCategoryNamePipe,
    WithCategoryPipe,
    FilterMatchedCategoriesPipe,
    SaleRequestAccessPipe,
    SaleInviteAccessPipe,
    CategroizedXraysPipe,
    IsSelectedStudiesPipe,
  ],
  imports: [CommonModule],
  exports: [
    FilterSaleHorsePipe,
    FilterStudyFilesByGroupPipe,
    FilterActiveGroupPipe,
    LeftOrRightPipe,
    FilterGroupsWithStudiesPipe,
    SortStudiesByCategoryPipePipe,
    WithStudyFilePipe,
    GetCategoryNamePipe,
    WithCategoryPipe,
    FilterMatchedCategoriesPipe,
    SaleRequestAccessPipe,
    SaleInviteAccessPipe,
    IsSelectedStudiesPipe,
    CategroizedXraysPipe
  ],
})
export class SharedNewPipesModule {}
